import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Scan, Database, CheckCircle } from 'lucide-react';

const HowItWorks = () => {
  const { t } = useLanguage();
  
  const steps = [
    {
      number: 1,
      icon: Scan,
      title: t('step1Title'),
      description: t('step1Desc'),
      color: '#D32F2F'
    },
    {
      number: 2,
      icon: Database,
      title: t('step2Title'),
      description: t('step2Desc'),
      color: '#D32F2F'
    },
    {
      number: 3,
      icon: CheckCircle,
      title: t('step3Title'),
      description: t('step3Desc'),
      color: '#D32F2F'
    }
  ];
  
  return (
    <section className="how-it-works-section">
      <div className="section-container">
        <h2 className="section-title">{t('howItWorksTitle')}</h2>
        
        <div className="steps-grid">
          {steps.map((step, index) => (
            <div key={step.number} className="step-card">
              <div className="step-number">{step.number}</div>
              
              <div className="step-icon-container">
                <step.icon className="step-icon" size={40} />
              </div>
              
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
              
              {index < steps.length - 1 && (
                <div className="step-connector"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
